<template>
  <section v-if="posts && posts.length > 0" class="blog">
    <div class="main-container">
      <h2 class="blog__header heading heading--md heading--underlined">
        Developers Updates
      </h2>
      <div v-if="bigPost" id="blog-latest">
        <big-post :post="bigPost" />
      </div>
      <div id="blog-list">
        <post v-for="post in posts" ref="posts" :key="post.id" :post="post" />
      </div>
      <div class="blog__all">
        <router-link :to="{ name: BLOG_PAGE_NAME }" class="blog__all-link">
          View all <i class="iconmoon-arrow_forward"></i>
        </router-link>
      </div>
    </div>
  </section>
</template>
<script>
import Post from "./Post.vue";
import BigPost from "./BigPost.vue";
import { BLOG_PAGE_NAME } from "../../../router/names";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    post: Post,
    "big-post": BigPost
  },
  data() {
    return {
      BLOG_PAGE_NAME
    };
  },
  computed: {
    ...mapGetters("posts", {
      posts: "microBlogPosts",
      bigPost: "bigPost"
    })
  },
  methods: {
    ...mapActions("posts", {
      fetch: "fetch"
    })
  },
  mounted() {
    this.fetch();
  }
};
</script>
